export default {
  logo: {
    'ui:widget': 'EditorUploadWidget',
  },
  text: {
    'ui:widget': 'EditorMarkdownWidget',
  },
  textColor: {
    'ui:widget': 'BaseColorWidget',
  },
  linkColor: {
    'ui:widget': 'BaseColorWidget',
  },
  bgImage: {
    'ui:widget': 'EditorUploadWidget',
  },
  bgColor: {
    'ui:widget': 'BaseColorWidget',
  },
  subscriptionButton: {
    color: {
      'ui:widget': 'BaseColorWidget',
    },
    colorHover: {
      'ui:widget': 'BaseColorWidget',
    },
    textColor: {
      'ui:widget': 'BaseColorWidget',
    },
  },
  additionalButtons: {
    items: {
      color: {
        'ui:widget': 'BaseColorWidget',
      },
      textColor: {
        'ui:widget': 'BaseColorWidget',
      },
    },
  },
}
